<template>
	<div>
		<div class="asd-margin" style="margin-top: 0px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/admin' }">智慧残联</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/admin/canxieManage' }">残协管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div style="margin-top: 10px;">
			<el-form :inline="true">
				<el-form-item size="mini" label="村(社区):">
					<el-input clearable v-model="selectform.name" placeholder="输入名字" style="width: 100px;"
						size="mini"></el-input>
				</el-form-item>
				<el-form-item v-if="false" size="mini" label="乡镇">

				</el-form-item>
				<el-button @click="page=1;getdata()" type="primary" size="mini">搜索</el-button>
			</el-form>
		</div>
		<div>
			<el-table size="mini" :row-class-name="tableRowClassName" :max-height="gettbheight" :data="tableData">
				<el-table-column type="index" label="序号"></el-table-column>
				<el-table-column prop="c_area" label="村(社区)"></el-table-column>
				<el-table-column prop="name" label="专职委员"></el-table-column>
				<el-table-column prop="phone" label="手机号"></el-table-column>
				<el-table-column prop="zhen_name" label="所属乡镇"></el-table-column>
				<el-table-column prop="leader" label="残协主席"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button size="mini" @click="changeA(scope.row,false)" type="text">修改信息</el-button>
						<el-button size="mini" style="color:orange" @click="changeA(scope.row,true)"
							type="text">查看详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :page-size="50" @current-change="getdata" :current-page.sync="page" :total="count"
				layout="total,prev, pager, next" background>
			</el-pagination>
		</div>
		<el-dialog :title="disabled?'查看信息':'修改信息'" :visible.sync="dialogVisible" width="30%"
			:before-close="handleClose">
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="村(社区)">
					<el-input disabled v-model="form.c_area"></el-input>
				</el-form-item>
				<el-form-item label="村协名称">
					<el-input :disabled="disabled" v-model="form.cx_name"></el-input>
				</el-form-item>
				<el-form-item label="专职委员">
					<el-input :disabled="disabled" v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input :disabled="disabled" v-model="form.phone"></el-input>
				</el-form-item>
				<el-form-item label="残协主席">
					<el-input :disabled="disabled" v-model="form.leader"></el-input>
				</el-form-item>
				<el-form-item label="村人口">
					<el-input :disabled="disabled" v-model="form.total"></el-input>
				</el-form-item>
				<el-form-item v-if="!disabled">
					<el-button type="primary" @click="changeCX">立即修改</el-button>
					<el-button @click="handleClose">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				disabled: true,
				form: {

				},
				tableData: [],
				count: 0,
				page: 1,
				selectform: {
					name: ""
				},
				dialogVisible: false
			}
		},
		computed: {

			gettbheight() {
				return window.innerHeight - 220;
			},
			info() {
				let info = window.localStorage.getItem("info");
				return JSON.parse(info);
			},
			org() {
				let org = window.localStorage.getItem("org");
				return JSON.parse(org);
			}
		},
		methods: {
			changeCX() {
				if (this.form.phone.length != 11) {
					this.$notify.error({
						title: '手机号错误',
						message: '请填写正确的手机号码'
					});
					return;
				};
				let form=JSON.parse(JSON.stringify(this.form));
				form.token=this.info.uid;
				axios.post(this.$url + "admin/changecx",form).then(res=>{
					console.log(res.data);
					this.$notify.success({
						title: '修改成功',
						message: '修改村残协信息成功'
					});
					this.dialogVisible=false;
					this.getdata();
				});
			},
			changeA(row, flag) {
				this.dialogVisible = true;
				this.form = row;
				this.disabled = flag;
			},
			handleClose(done) {
				this.dialogVisible = false;
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (!row.phone||row.phone.length != 11) {
					return "error-row";
				}
				return '';
			},
			async getdata() {
				
				let ans = await axios.get(this.$url + "admin/cxlists", {
					params: {
						token: this.info.uid,
						org_id: this.org.area,
						page: this.page - 1,
						kw:this.selectform.name
					}
				});
				console.log(ans);
				this.tableData = ans.data.lists;
				this.count = ans.data.count;
			}

		},
		async created() {
			this.getdata();
		}
	}
</script>

<style>
	.el-table .error-row {
		background: orangered;
	}
</style>